module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-71.2a4a2383.svg";